import {memo} from 'react';

import styled from 'styled-components';

import ImageWithAlt from '~/shared/components/ImageWithAlt';

import highSugarImage from './assets/high-sugar.png';
import highSodiumImage from './assets/high-sodium.png';
import highSaturatedFatImage from './assets/high-saturated-fat.png';

const Root = styled.div`
  display: flex;
  margin-top: 8px;
`;

const StyledWarningSticker = styled(ImageWithAlt)`
  width: 60px;
  height: 60px;
`;

const HighStatsAlerts = ({showHighSugarAlert, showHighSaturatedFatAlert, showHighSodiumAlert}: {showHighSugarAlert: boolean; showHighSaturatedFatAlert: boolean; showHighSodiumAlert: boolean}) => {
  if (!showHighSugarAlert && !showHighSaturatedFatAlert && !showHighSodiumAlert) {
    return null;
  }
  
  return (
    <Root>
      {showHighSugarAlert && <StyledWarningSticker src={highSugarImage} alt="סוכר בכמות גבוהה" />}
      {showHighSaturatedFatAlert && <StyledWarningSticker src={highSaturatedFatImage} alt="שומן רווי בכמות גבוהה" />}
      {showHighSodiumAlert && <StyledWarningSticker src={highSodiumImage} alt="נתרן בכמות גבוהה" />}
    </Root>
  );
};

export default memo(HighStatsAlerts);
